import { render, staticRenderFns } from "./CreateFixedRentalSettings.vue?vue&type=template&id=f737d13e"
import script from "@/scripts/components/fixedRental/createFixedRentalSettings.js?vue&type=script&lang=js&external"
export * from "@/scripts/components/fixedRental/createFixedRentalSettings.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports